import { safeExecute } from "@opendaw/lib-std";
import { Box, NoPointers, PointerField, Int32Field, StringField, BooleanField, Float32Field, } from "@opendaw/lib-box";
import { Pointers } from "@opendaw/studio-enums";
export class CrusherDeviceBox extends Box {
    static create(graph, uuid, constructor) {
        return graph.stageBox(new CrusherDeviceBox({
            uuid,
            graph,
            name: "CrusherDeviceBox",
            pointerRules: {
                accepts: [
                    Pointers.Device,
                    Pointers.Selection,
                    Pointers.MetaData,
                    Pointers.SideChain,
                ],
                mandatory: false,
                exclusive: false,
            },
        }), constructor);
    }
    static ClassName = "CrusherDeviceBox";
    constructor(construct) {
        super(construct);
    }
    accept(visitor) {
        return safeExecute(visitor.visitCrusherDeviceBox, this);
    }
    get host() {
        return this.getField(1);
    }
    get index() {
        return this.getField(2);
    }
    get label() {
        return this.getField(3);
    }
    get enabled() {
        return this.getField(4);
    }
    get minimized() {
        return this.getField(5);
    }
    get crush() {
        return this.getField(10);
    }
    get bits() {
        return this.getField(11);
    }
    get boost() {
        return this.getField(12);
    }
    get mix() {
        return this.getField(13);
    }
    initializeFields() {
        return {
            1: PointerField.create({
                parent: this,
                fieldKey: 1,
                fieldName: "host",
                deprecated: false,
                pointerRules: NoPointers,
            }, Pointers.AudioEffectHost, true),
            2: Int32Field.create({
                parent: this,
                fieldKey: 2,
                fieldName: "index",
                deprecated: false,
                pointerRules: NoPointers,
            }, "index", ""),
            3: StringField.create({
                parent: this,
                fieldKey: 3,
                fieldName: "label",
                deprecated: false,
                pointerRules: NoPointers,
            }),
            4: BooleanField.create({
                parent: this,
                fieldKey: 4,
                fieldName: "enabled",
                deprecated: false,
                pointerRules: NoPointers,
            }, true),
            5: BooleanField.create({
                parent: this,
                fieldKey: 5,
                fieldName: "minimized",
                deprecated: false,
                pointerRules: NoPointers,
            }, false),
            10: Float32Field.create({
                parent: this,
                fieldKey: 10,
                fieldName: "crush",
                deprecated: false,
                pointerRules: {
                    accepts: [
                        Pointers.Modulation,
                        Pointers.Automation,
                        Pointers.MIDIControl,
                    ],
                    mandatory: false,
                    exclusive: false,
                },
            }, "unipolar", "%", 0),
            11: Int32Field.create({
                parent: this,
                fieldKey: 11,
                fieldName: "bits",
                deprecated: false,
                pointerRules: {
                    accepts: [
                        Pointers.Modulation,
                        Pointers.Automation,
                        Pointers.MIDIControl,
                    ],
                    mandatory: false,
                    exclusive: false,
                },
            }, { min: 1, max: 16 }, "bits", 16),
            12: Float32Field.create({
                parent: this,
                fieldKey: 12,
                fieldName: "boost",
                deprecated: false,
                pointerRules: {
                    accepts: [
                        Pointers.Modulation,
                        Pointers.Automation,
                        Pointers.MIDIControl,
                    ],
                    mandatory: false,
                    exclusive: false,
                },
            }, { min: 0, max: 24, scaling: "linear" }, "dB", 0),
            13: Float32Field.create({
                parent: this,
                fieldKey: 13,
                fieldName: "mix",
                deprecated: false,
                pointerRules: {
                    accepts: [
                        Pointers.Modulation,
                        Pointers.Automation,
                        Pointers.MIDIControl,
                    ],
                    mandatory: false,
                    exclusive: false,
                },
            }, "unipolar", "%", 1),
        };
    }
}
